import axios from "axios";
import config from "../config";
import { ShareResponse } from "./ResponseModels/ShareResponse";

export async function GetShareModel(token: string) {
  let response = null;
  response = axios
    .get<ShareResponse>(config.getShareEndpoint, {
      params: {
        encryptedString: token,
      },
    })
    .catch((e) => {
      // TODO manage
      console.error("There was an error!", e);
    });

  return response;
}
